import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import { useState } from "react";
import { AffiliateDto } from "../../generated/dashboard-client";
import MembersApi from "../../api/MembersApi";
import "./PartnerForm.scss";

const {TextArea} = Input;

interface PartnerFormProps {
  setSubmitted: (submitted: boolean) => void;
  formWidth: number;
}

export default function PartnerForm({setSubmitted, formWidth} : PartnerFormProps) {
  const [submitting, setSubmitting] = useState(false);
  
  function onFinish(values: any) {
    setSubmitting(true);
    let affiliate = {
      business: values.business,
      website: values.website,
      email: values.email,
      phone: values.phone,
      firstName: values.firstName,
      lastName: values.lastName,
      reason: values.reason
    } as AffiliateDto;
    
    MembersApi.sendAffiliateLead(affiliate).then(() => {
      console.log(affiliate);
      console.log('affiliate lead sent');
      setSubmitting(false);
      setSubmitted(true);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }).catch((err) => {
      setSubmitting(false);
      console.error(err);
    })
  }

  return (<div className="affiliate-form">
      <Form
        name="basic"
        wrapperCol={{ span: 24 }}
        style={{ maxWidth: formWidth, margin: 'auto' }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          name="business"
          rules={[{ required: true, message: 'Please input your company name' }]}
        >
        <Input placeholder="Company Name" />
        </Form.Item>

        <Form.Item
          name="website"
          rules={[{ required: true, message: 'Please input your website' }]}
        >
          <Input placeholder="Company Website" />
        </Form.Item>

        <Form.Item
          name="email"
          rules={[{ required: true, message: 'Please input your contact email' }]}
          style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
        >
          <Input placeholder="Contact Email" />
        </Form.Item>
        <Form.Item
          name="phone"
          rules={[{ required: true, message: 'Please input your phone number' }]}
          style={{ display: 'inline-block', width: 'calc(50% - 4px)', marginLeft: '8px' }}
        >
          <Input placeholder="Contact Phone" />
        </Form.Item>

        <Form.Item
          name="firstName"
          rules={[{ required: true, message: 'Please input your first name' }]}
          style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
        >
          <Input placeholder="First Name" />
        </Form.Item>
        <Form.Item
          name="lastName"
          rules={[{ required: true, message: 'Please input your last name' }]}
          style={{ display: 'inline-block', width: 'calc(50% - 4px)', marginLeft: '8px' }}
        >
          <Input placeholder="Last Name" />
        </Form.Item>

        <Form.Item
          name="reason"
          rules={[{ required: true, message: 'Please input your reason' }]}
        >
          <TextArea 
            rows={6} 
            placeholder="Why do you want to partner with MustHaveMenus?"
            style={{ resize: 'none' }}
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            {!submitting && <span>Let's Get Cookin'</span>}
            {submitting && <LoadingOutlined/>}
          </Button>
        </Form.Item>
      </Form>
  </div>);
}